import {useQuery} from '@tanstack/react-query';
import {useModule} from '@/hooks/useModule';
import {useSelectors} from '@/store/kysely_module';

type UseAvatarImageOptions = {
    enabled?: boolean;
};

export const useAvatarImage = (
    userId: string,
    fileId: string | null,
    updatedAt: string | null,
    options?: UseAvatarImageOptions
) => {
    const filesModule = useModule('MSFiles');
    const selectors = useSelectors();

    const queryKey = ['avatar', fileId];

    const query = useQuery({
        queryKey,
        queryFn: async () => {
            if (!fileId) {
                return null;
            }

            const file = await selectors.getAvatarFileInfo({file_id: fileId}, {workspace_id: userId});

            if (!file) {
                return null;
            }

            const presignedUrl = await filesModule.client().getFileSrc(file);

            if (!presignedUrl) {
                return null;
            }

            return presignedUrl;
        },
        enabled: options?.enabled !== false && !!fileId,
        staleTime: 45 * 60 * 1000,
        retry: false,
    });

    return query;
};
